import { render, staticRenderFns } from "./FieldPimReference.vue?vue&type=template&id=195baba5&"
import script from "./FieldPimReference.vue?vue&type=script&lang=js&"
export * from "./FieldPimReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports